import { Contact } from '../../../domain/customerContact/Contact';
import { ContactList } from '../../../domain/customerContact/contactList';
import { CustomerList } from '../../../domain/customers/customerList';
import { ContactDTO } from '../../http/dtos/customer-contacts/contactDTO';
import { ContactListDTO } from '../../http/dtos/customer-contacts/contactListDTO';

const getContactsListAdapter = (responseAPI: ContactListDTO[]): ContactList[] => {
    return responseAPI
        ? responseAPI.map((contacts) => {
              return {
                  id: contacts.id,
                  documentNumber: contacts.documentNumber,
                  email: contacts.email,
                  cellphoneNumber: contacts.cellphoneNumber,
                  firstName: contacts.firstName,
                  middleName: contacts.middleName,
                  lastName: contacts.lastName,
                  surname: contacts.surname,
                  position: contacts.position,
              };
          })
        : [];
};

const getContactAdapter = (responseAPI: ContactDTO): Contact => {
    return {
        id: responseAPI.id,
        cityName: responseAPI.cityName,
        email: responseAPI.email,
        phoneNumber: responseAPI.phoneNumber,
        cellphoneNumber: responseAPI.cellphoneNumber,
        cityId: responseAPI.cityId,
        firstName: responseAPI.firstName,
        middleName: responseAPI.middleName,
        lastName: responseAPI.lastName,
        surname: responseAPI.surname,
        customerId: responseAPI.customerId,
        customerName: responseAPI.customerName,
        position: responseAPI.position,
    };
};

export const ContactAdapter = {
    getContactAdapter,
    getContactsListAdapter,
};
